<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-crypto__commodity">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-select v-model="dataForm.chainId" placeholder="选择区块链" clearable @change="chainChangeHandle">
            <el-option v-for="item in chainList" :key="item.id" :label="item.chainName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.tokenId" placeholder="选择代币" clearable>
            <el-option v-for="item in filteredTokenList" :key="item.id" :label="item.tokenName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.commodityType" placeholder="商品类型" clearable>
            <el-option label="金币" :value="1"></el-option>
            <el-option label="VIP" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('crypto:commodity:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('crypto:commodity:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="commodityName" label="显示名称" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="price" label="商品价格" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.price ? parseFloat(scope.row.price).toFixed(2) : '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="commoditySpecification" label="商品规格" header-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="chainName" label="区块链" header-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="tokenName" label="代币名称" header-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="status" label="是否开启" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" size="success" type="success">是</el-tag>
            <el-tag v-if="scope.row.status === 2" size="warning" type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="商品排序" header-align="center" align="center" width="100"></el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('crypto:commodity:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('crypto:commodity:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './crypto-commodity-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/crypto/commodity/list',
        getDataListIsPage: true,
        deleteURL: '/crypto/commodity',
        deleteIsBatch: true
      },
      dataForm: {
        chainId: '',
        tokenId: '',
        commodityType: ''
      },
      chainList: [],
      tokenList: []
    }
  },
  components: {
    AddOrUpdate
  },
  created () {
    this.getChainList()
    this.getTokenList()
  },
  computed: {
    // 根据选择的区块链过滤代币列表
    filteredTokenList () {
      if (!this.dataForm.chainId) {
        return this.tokenList
      }
      return this.tokenList.filter(token => token.pid === this.dataForm.chainId)
    }
  },
  methods: {
    getChainList () {
      this.$http.get('/crypto/chain/enabled').then(({ data: res }) => {
        if (res.code === 0) this.chainList = res.data
      }).catch(() => {})
    },
    getTokenList () {
      this.$http.get('/crypto/token/enabled').then(({ data: res }) => {
        if (res.code === 0) this.tokenList = res.data
      }).catch(() => {})
    },
    // 区块链改变时，清空已选择的代币
    chainChangeHandle (val) {
      this.dataForm.tokenId = ''
    }
  }
}
</script>
